
export const BUILD_NO = "84"
export const APP_VERSION = "0.0.84"


export const userTypes = [
    { label: "Driver", value: "driver" },
    { label: "Individual User", value: "individual" },
    { label: "Business user", value: "business" },
];